<template>
  <a class="accessibility" href="#main">Skip to Content</a>
  <noscript>
    <div>Javascript must be enabled for the correct page display</div>
  </noscript>
  <div class="wrapper settings-wrapper">
    <!-- Mobile shell: settings pages are drill-down screens under the
         Account tab — compact back header instead of the desktop nav. -->
    <MobileDetailHeader
      v-if="isMobile"
      :title="mobileTitle"
      back-label="Back to account"
      back-to="/account"
      :show-actions="false"
    />
    <SettingsNavigation v-if="!isMobile"></SettingsNavigation>
    <!-- Target of the skip link above and of focus after navigation
         (router/route-focus.js). -->
    <main id="main">
      <slot />
    </main>
  </div>
  <PopupContainer></PopupContainer>
</template>

<script>
import SettingsNavigation from "@/components/SettingsNavigation.vue";
import PopupContainer from "@/components/PopupContainer.vue";
import MobileDetailHeader from "@/components/mobile-shell/MobileDetailHeader.vue";
import { useIsMobile } from "@/composables/useIsMobile";

export default {
  name: "SettingsLayout",
  components: {
    SettingsNavigation,
    PopupContainer,
    MobileDetailHeader,
  },
  setup() {
    const { isMobile } = useIsMobile();
    return { isMobile };
  },
  computed: {
    mobileTitle() {
      return this.$route?.meta?.mobileTitle || "Settings";
    },
  },
};
</script>
